module.exports = __webpack_public_path__ + "static/body-40272d566de2c58f1db31d4c26b7a37f.png";